/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/useStickyOffset.ts
 * FILE_ID: JOBHUB-QA-STICKY-OFFSET-001
 * PURPOSE: Measure a sticky header so later sticky siblings can sit under it.
 * LANDMINE: Guessed top-10 offsets hide chips when the header wraps.
 */
import { useEffect, useRef, useState } from 'react'

export function useStickyOffset<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const node = ref.current
    if (!node || typeof ResizeObserver === 'undefined') return
    const update = () => setHeight(node.getBoundingClientRect().height)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  return { ref, height }
}
